import { createStore, combineReducers, applyMiddleware } from "redux"
import { thunk } from "redux-thunk"
import { GetAllSystems, GetSystemByName, AddSystem } from "./reducers/SystemReducer"
import { 
  GetAllClients, 
  GetClientById, 
  AddClient,
  UpdateClientStatus  // ADD THIS
} from "./reducers/ClientReducer"
import { 
  GetAllBusinesses, 
  AddBusiness,
  GetBusinessInteractionLog,  
  AddBusinessLog,
  DeleteBusinessLog
} from "./reducers/BusinessReducer"
import {
  GetAllLicenses,
  GetLicenseById,
  GetAllActiveLicenses,
  AddLicense,
  UpdateLicenseStatus,
} from "./reducers/LicenseReducer"
import {
  GetAllPayments,
  GetPaymentById,
  GetPaymentDetailsById,
  AddPayment,
  UpdatePayment,
} from "./reducers/PaymentReducer"

const rootReducer = combineReducers({
  system: GetAllSystems,
  namesystemem: GetSystemByName,
  addsystem: AddSystem,
  
  allclients: GetAllClients,
  clientbyid: GetClientById,
  addclient: AddClient,
  updateclientstatus: UpdateClientStatus, // ADD THIS
  
  allbusinesses: GetAllBusinesses,
  addbusiness: AddBusiness,
  
  // Business Log Reducers
  businesslog: GetBusinessInteractionLog,
  addbusinesslog: AddBusinessLog,
  deletebusinesslog: DeleteBusinessLog,
  
  alllicenses: GetAllLicenses,
  licensebyid: GetLicenseById,
  allactivelicenses: GetAllActiveLicenses,
  addlicense: AddLicense,
  updatelicensestatus: UpdateLicenseStatus,
  
  allpayments: GetAllPayments,
  paymentbyid: GetPaymentById,
  paymentdetailsbyid: GetPaymentDetailsById,
  addpayment: AddPayment,
  updatepayment: UpdatePayment,
})

const store = createStore(rootReducer, applyMiddleware(thunk))

export default store;